
export const INTERMEDIATE_TIER_DEFAULT_VALUES = {
  trainingHistory: "less_than_6_months" as const,
  currentRoutine: "",
  plateaus: "",
  performanceMetrics: "",
};

export const INTERMEDIATE_TIER_TITLE = "Intermediate Program Questions";
export const INTERMEDIATE_TIER_DESCRIPTION = "Building strength and endurance with moderate complexity and increasing intensity, for those with some training experience.";
